import {defineField, defineType} from 'sanity'
import {BiCollection} from 'react-icons/bi'
import {createUniqueFieldValidator} from '../../lib/validations'

export default defineType({
  name: 'blog.category-cluster',
  title: 'Category Cluster',
  type: 'document',
  icon: BiCollection,
  groups: [{name: 'content', default: true}, {name: 'metadata'}],
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      group: 'content',
      validation: (rule) =>
        rule
          .required()
          .custom(
            createUniqueFieldValidator(
              'blog.category-cluster',
              'title',
              'A category cluster with this title already exists',
            ),
          ),
    }),
    defineField({
      name: 'video',
      type: 'boolean',
      title: 'Video cluster',
      description: 'Flags this cluster as video content.',
      initialValue: false,
      group: 'content',
    }),
    defineField({
      name: 'subtitle',
      title: 'Subtitle',
      description: 'This field is dedicated to the hero of the video cluster page.',
      type: 'string',
      group: 'content',
    }),
    defineField({
      name: 'content',
      title: 'Content',
      description: 'This field is dedicated to the hero of the video cluster page.',
      type: 'portableText',
      group: 'content',
    }),
    defineField({
      name: 'excludeFromInternalSearch',
      type: 'boolean',
      title: 'Exclude from internal search',
      description: 'Exclude the posts in this category from the internal search results',
      group: 'metadata',
    }),
    defineField({
      name: 'metadata',
      type: 'metadata',
      group: 'metadata',
    }),
    defineField({
      name: 'wpId',
      type: 'number',
      title: 'WordPress ID',
      description: 'WordPress category ID for sync tracking',
      group: 'metadata',
      readOnly: true,
    }),
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'slug.current',
    },
  },
})
